import { push, replace } from 'connected-react-router';
import { routerActions } from './locationChangeMiddleware';
import { syncProductAddresses } from '../carts/actions';
import { assignCartProductGroups } from '../carts/actionCreators';

const ROUTES = ['/checkout', '/order-confirmation'];

/**
 * Disallows direct navigation to Checkout & Checkout Confirmation.
 * @param store
 * @returns {function(*): function(...[*]=)}
 */
export const checkoutAuthorizationMiddleware = store => next => async action => {
  const { payload } = action;

  if (action.type === routerActions.LOCATION_CHANGE && payload.location && ROUTES.includes(payload.location.pathname)) {
    const { dispatch, getState } = store;
    const state = getState();

    // We may only navigate to checkout via app dispatched location change event
    if (payload.isFirstRendering) {
      return dispatch(push('/'));
    }
    if (payload.action === 'POP') {
      const currentPath = state.router.location.pathname;
      return dispatch(replace(currentPath));
    }

    // Assign cart item groups before navigating to the checkout page
    await dispatch(assignCartProductGroups());

    // Sync/update product addresses by product group addresses
    dispatch(syncProductAddresses());
  }

  return next(action);
};
